<script setup lang="ts">
import OutlineButton from '@/Components/Buttons/OutlineButton.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import { Link, usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const user = computed(() => usePage().props.auth.user)
</script>

<template>
    <div class="grid w-full space-y-2 text-center">
        <template v-if="!user">
            <Link
                href="/#Sicherheitsvorteile"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Ihre Sicherheitsvorteile
            </Link>
            <Link
                href="/#SoEinfachFunktionierts"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                So einfach funktioniert's
            </Link>
            <Link
                href="/#Preise"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Preise
            </Link>
            <Link
                href="/#Sicherheitsvorteile"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Häufige Fragen (FAQ)
            </Link>
        </template>
        <template v-if="user && !user.is_subscribed">
            <Link
                :href="route('secrets.create')"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Neues Geheimnis erstellen
            </Link>
            <Link
                :href="route('dashboard')"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Meine Geheimnisse
            </Link>
            <Link
                href="/#Preise"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Mehr erreichen mit Pro
            </Link>
            <Link
                href="/#Preise"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Preise
            </Link>
            <Link
                href="/#FAQ"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Häufige Fragen (FAQ)
            </Link>
        </template>
        <template v-if="user && user.is_subscribed">
            <Link
                :href="route('secrets.create')"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Neues Geheimnis erstellen
            </Link>
            <Link
                :href="route('dashboard')"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Meine Geheimnisse
            </Link>
            <Link
                :href="route('secret-requests.index')"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Anforderungslinks
            </Link>
            <Link
                href="/#FAQ"
                class="rounded-3xl px-3 py-2 font-bold text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
            >
                Häufige Fragen (FAQ)
            </Link>
        </template>
    </div>
    <div class="mt-12 grid text-center">
        <Link
            :href="route('trust-center')"
            class="px-3 py-2 text-gray-900 uppercase transition-all duration-300 rounded-3xl hover:bg-black/5 hover:text-primary-500 hover:underline"
        >
            Trust Center
        </Link>
        <Link
            :href="route('imprint')"
            class="rounded-3xl px-3 py-2 uppercase text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
        >
            Impressum
        </Link>
        <Link
            :href="route('privacy-policy')"
            class="rounded-3xl px-3 py-2 uppercase text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
        >
            Datenschutzhinweise
        </Link>
        <Link
            :href="route('agb')"
            class="rounded-3xl px-3 py-2 uppercase text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
        >
            AGB
        </Link>
        <Link
            :href="route('contact')"
            class="rounded-3xl px-3 py-2 uppercase text-gray-900 transition-all duration-300 hover:bg-black/5 hover:text-primary-500 hover:underline"
        >
            Kontakt
        </Link>
    </div>
    <div class="mt-8 grid space-y-4 text-center">
        <template v-if="!user">
            <OutlineButton
                href="/#Preise"
                class="border-primary-500 text-primary-500"
                icon="fa-shart fa-regular fa-rocket-launch"
            >
                Mehr erreichen mit Professional Abo
            </OutlineButton>
            <PrimaryButton
                v-if="!user"
                :link="route('register')"
                icon="fa-light fa-user-plus"
            >
                Kostenlos registrieren
            </PrimaryButton>
        </template>
        <template v-if="user && !user.is_subscribed">
            <PrimaryButton
                link="/#Preise"
                icon="fa-shart fa-regular fa-rocket-launch"
            >
                Upgrade auf Pro
            </PrimaryButton>
        </template>
    </div>
</template>
